import MyAccount from './components/MyAccount';

export const accountRoutes = [
  {
    path: '/',
    exact: true,
    className: '',
    component: MyAccount,
    id: 'my-account',
  },
];
